import $ from 'jquery';
import { getHeight, getScrollTop } from '../utils/window';

export default function hero() {
	const $html = $('html');
   const $scroller = $('html, body');

   const HERO = $('#hero');
   const VOLUME = HERO.find('.volume');
   const VID = HERO.find('.media video');

   $(function(){
      if(VID.length) {
         VID.get(0).play();

         VOLUME.click(function(){
            VOLUME.toggleClass('is-muted');
      
            if(VOLUME.hasClass('is-muted')) {
               VID.prop('muted', true);
            } else {
               VID.prop('muted', false);
            }
         });
      }
   });

  // close popup
  const popup = document.querySelector('div.popup');
  if (popup) {
    const closePopup = () => popup.classList.remove('popped');
    popup.addEventListener('click', closePopup);
  }

  // queu popup
  const queuePopup = () => {
    if (popup) {
      setTimeout(() => {
        popup.classList.add('popped');
      }, 1200);
    }
  }

  // preloader shit
  if($('.preloader').length) {
    window.onload = function() {
      setTimeout(function() {
        $('.preloader').addClass('is-loaded');
        setTimeout(function() {
          $('.preloader').fadeOut('slow', function(){
            $('.preloader').remove();
          });
          queuePopup();
        }, 1500);
      }, 300);
    }
  } else {
    queuePopup();
  }
}


// WEBPACK FOOTER //
// ./source/scripts/sections/hero.js